import React, { useState } from "react";
import "./ProcessStepSelector.css";

const ProcessStepSelector = ({ stepsData }) => {
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const CurrentTabComponent = stepsData[activeStepIndex].Component;

  const handleSelectOption = (index) => {
    setActiveStepIndex(index);
    setIsDropdownOpen(false); // Close dropdown after selection
  };

  return (
    <div className="process-step-selector-container">
      {/* Desktop Tabs */}
      <div className="step-tabs-desktop" role="tablist">
        {stepsData.map((step, index) => (
          <button
            key={index}
            onClick={() => setActiveStepIndex(index)}
            className={`step-tab-button ${
              index === activeStepIndex ? "active" : ""
            }`}
            role="tab"
          >
            {step.label}
          </button>
        ))}
      </div>

      {/* Mobile Dropdown */}
      <div className="step-tabs-mobile-dropdown">
        <button
          className="dropdown-toggle-button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          aria-haspopup="true"
          aria-expanded={isDropdownOpen}
        >
          {stepsData[activeStepIndex].label}
          <span
            className={`dropdown-arrow ${isDropdownOpen ? "open" : ""}`}
          ></span>
        </button>
        {isDropdownOpen && (
          <div className="dropdown-menu-mobile">
            {stepsData.map((step, index) => (
              <button
                key={index}
                onClick={() => handleSelectOption(index)}
                className="dropdown-item"
              >
                {step.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Content Area */}
      <div className="step-content-area">
        <CurrentTabComponent setActiveStepIndex={setActiveStepIndex} />
      </div>
    </div>
  );
};

export default ProcessStepSelector;
